import { RectangularName, SquareName } from "@timesheets/constants-common";

import { IState } from "@/vuex/IState";
import { Store } from "vuex";

export function getHeaderImageUrl(tenantName: string, isRectangular: boolean, store: Store<IState>): string {
  let tenantLogoPaths = store.state.logoPaths[tenantName];
  if (!tenantLogoPaths) {
    store.dispatch("updateLogoTimestamp", { logoType: isRectangular ? RectangularName : SquareName, tenantName });
    tenantLogoPaths = store.state.logoPaths[tenantName];
  }

  return isRectangular ? tenantLogoPaths.rectangular : tenantLogoPaths.square;
}
